import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export interface ActionsProps {
  onContinue?: () => void;
  onBack?: () => void;
  onSkip?: () => void;
  /** Disable the Continue button (e.g. required field empty) */
  continueDisabled?: boolean;
  /** Override the Continue label — defaults to "Continue" */
  continueLabel?: string;
  /** Hide the Back button — set on the welcome step */
  hideBack?: boolean;
  /** Hide the Skip button — set on terminal / required steps */
  hideSkip?: boolean;
}

export function Actions({
  onContinue,
  onBack,
  onSkip,
  continueDisabled = false,
  continueLabel = 'Continue',
  hideBack = false,
  hideSkip = false,
}: ActionsProps) {
  return (
    <div className="aa-actions">
      <div style={{ display: 'flex', gap: '8px' }}>
        {!hideBack && (
          <button type="button" className="aa-btn aa-btn-ghost" onClick={onBack}>
            <ArrowLeft size={14} strokeWidth={2.5} aria-hidden="true" />
            Back
          </button>
        )}
        {!hideSkip && (
          <button type="button" className="aa-btn aa-btn-ghost" onClick={onSkip}>
            Skip for now
          </button>
        )}
      </div>
      <button
        type="button"
        className="aa-btn aa-btn-primary"
        onClick={onContinue}
        disabled={continueDisabled}
      >
        {continueLabel}
        <ArrowRight size={14} strokeWidth={2.5} aria-hidden="true" />
      </button>
    </div>
  );
}

export default Actions;
